module.exports = __webpack_public_path__ + "img/logo5.dce6099f.png";